import { render, staticRenderFns } from "./formLabel.vue?vue&type=template&id=af923250&scoped=true"
import script from "./formLabel.vue?vue&type=script&lang=js"
export * from "./formLabel.vue?vue&type=script&lang=js"
import style0 from "./formLabel.vue?vue&type=style&index=0&id=af923250&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af923250",
  null
  
)

export default component.exports